import { ITextConverter } from "@tblabs/storage";
import { ChatEntry, ContentType, PictureChatEntry, MessageChatEntry } from "../Models/ChatEntry";


export class ChatEntryConverter implements ITextConverter<ChatEntry>
{
    private SPLITTER = "|";

    public ToLine(entry: ChatEntry): string
    {
        return `${entry.Id}${this.SPLITTER}${entry.Time}${this.SPLITTER}${entry.AuthorId}${this.SPLITTER}${entry.ContentType}${this.SPLITTER}${entry.Content}`;
    }

    public ToEntry(line: string): ChatEntry
    {
        const elements = line.split(this.SPLITTER);

        const id = elements[0];
        const time = elements[1];
        const userId = elements[2];
        const contentType = elements[3];
        const content = elements[4];

        if (contentType === ContentType.Pictures)
        {
            return new PictureChatEntry(id, time, userId, content);
        }
        else if (contentType === ContentType.Message)
        {
            return new MessageChatEntry(id, time, userId, content);
        }

        throw new Error(`Invalid content type: ${contentType}`);
    }
}
